import React, { useCallback, useEffect, useState } from "react";
import FaiBox from "../../MuiComponents/FaiBox";
import { Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import BasicDetails from "./BasicDetails";
import theme from "../../assets/theme";
import BusinessDetails from "./BusinessDetails";
import BrandDetails from "./BrandDetails";
import BankDetails from "./BankDetails";
import FaiFormStepper from "components/Stepper";
import Declaration from "./Declaration";

export default function OnBoarding() {
	const { palette } = theme;
	const navigate = useNavigate();
	const location = useLocation();
	const [activeStep, setActiveStep] = useState(0);
	const [declaration, setDeclaration] = useState(false);

	useEffect(() => {
		const currentStep = location.pathname.split("/").pop();
		const foundStepIndex = steps.findIndex((step) => step.id === currentStep);
		setActiveStep(foundStepIndex !== -1 ? foundStepIndex : 0);
	}, [location.pathname]);

	const handleNewStep = useCallback(
		(index: number, id: string) => {
			if (activeStep !== index) {
				const newPath = location.pathname.replace(/[^/]*$/, id);
				setActiveStep(index);
				navigate(newPath);
			}
		},
		[activeStep, location.pathname, navigate]
	);

	const onNextStep = useCallback(() => {
		if (activeStep < 3) {
			handleNewStep(activeStep + 1, steps[activeStep + 1].id);
		} else setDeclaration(true);
	}, [activeStep, handleNewStep]);

	return (
		<FaiBox className="mt-20">
			<FaiBox
				className="relative pt-20 rounded-t-lg"
				bgColor={palette.white.main}
			>
				<Box className="absolute w-full" sx={{ top: "-90px" }}>
					<FaiFormStepper
						activeStep={activeStep}
						handleNewStep={handleNewStep}
						steps={steps}
					/>
				</Box>
			</FaiBox>
			<FaiBox>
				{activeStep === 0 && <BasicDetails onNextStep={onNextStep} />}
				{activeStep === 1 && <BusinessDetails onNextStep={onNextStep} />}
				{activeStep === 2 && <BrandDetails onNextStep={onNextStep} />}
				{activeStep === 3 && <BankDetails onNextStep={onNextStep} />}
			</FaiBox>
			{declaration && <Declaration onClose={() => setDeclaration(false)} />}
		</FaiBox>
	);
}

export const steps = [
	{ id: "basicDetails", label: "Basic Details" },
	{ id: "businessdetails", label: "Business Details" },
	{ id: "brandDetails", label: "Brand Details" },
	{ id: "bankdetails", label: "Bank Details" },
];
